import type { ReactElement } from 'react';
import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import FormButtonsContainer from 'atom-components/form-buttons-container';
import Heading from 'atom-components/heading';
import type { AllocationResults } from 'pages/marking/subpages/marking-allocation-tab/types';
import AllocatedMarkersTable from './allocated-markers-table';
import UnallocatedMarkersTable from './unallocated-markers-table';
import styles from './index.module.scss';

type Props = {
  isOpen: boolean;
  onClose(): void;
  allocationResults: AllocationResults;
};

export default function AllocationResultsModal({
  isOpen,
  onClose,
  allocationResults
}: Props): ReactElement {
  return (
    <Modal isOpen={isOpen} size="lg" scrollable>
      <ModalHeader toggle={onClose}>Allocation Results</ModalHeader>
      <ModalBody>
        <div className={styles.resultsTables}>
          {allocationResults.allocatedMarkers.length > 0 && (
            <div>
              <Heading level={3} className={styles.heading}>
                The following markers were successfully allocated:
              </Heading>
              <AllocatedMarkersTable allocatedMarkers={allocationResults.allocatedMarkers} />
            </div>
          )}
          {allocationResults.unallocatedMarkers.length > 0 && (
            <div>
              <Heading level={3} className={styles.heading}>
                The following markers could not be allocated:
              </Heading>
              <UnallocatedMarkersTable allocationResults={allocationResults} />
            </div>
          )}
        </div>
        <FormButtonsContainer>
          <Button color="primary" onClick={onClose}>
            Continue
          </Button>
        </FormButtonsContainer>
      </ModalBody>
    </Modal>
  );
}
